document.addEventListener('DOMContentLoaded', () => {
	const popup = document.querySelector('.newsletter-modal');
	if (!popup) return;

	const now = Date.now();
	const closedAt = localStorage.getItem('klav_popup_closed_at');
	const submittedAt = localStorage.getItem('klav_popup_submitted');
	const sessionShown = sessionStorage.getItem('klav_popup_shown');

	const SUPPRESS_CLOSE = 7 * 24 * 60 * 60 * 1000; // 7 days
	const SUPPRESS_SUBMIT = 90 * 24 * 60 * 60 * 1000; // 90 days
    const KLAVIYO_FORM_ID = 'QZErH5';


	const path = window.location.pathname;
	if (path.includes('/cart') || path.includes('/checkout')) return;

	
	if (sessionShown) return;
	if (closedAt && now - closedAt < SUPPRESS_CLOSE) return;
	if (submittedAt && now - submittedAt < SUPPRESS_SUBMIT) return;

	let engagementTriggered = false;
	const showPopup = () => {
		if (engagementTriggered) return;
		engagementTriggered = true;
        
		popup.classList.remove('hidden');
		sessionStorage.setItem('klav_popup_shown', 'true');
	};

	// Show after 10s
	const timer = setTimeout(showPopup, 10000);

	// Or after 40% scroll
	const onScroll = () => {
		const scrollPercent =
			(window.scrollY + window.innerHeight) / document.body.scrollHeight;
		if (scrollPercent >= 0.4) {
			clearTimeout(timer);
			showPopup();
			window.removeEventListener('scroll', onScroll);
		}
	};
	window.addEventListener('scroll', onScroll);

	// Handle close
    document.querySelector('.newsletter__close').addEventListener('click', () => {
        popup.classList.add('hidden');
        localStorage.setItem('klav_popup_closed_at', Date.now());
    });

	// Handle Klaviyo form submit
	window.addEventListener('klaviyoForms', function (e) {
		if (e.detail.type === 'submit' && e.detail.formId == KLAVIYO_FORM_ID) {
			popup.classList.add('hidden');
			localStorage.setItem('klav_popup_submitted', Date.now());
		}
	});
});


